import { render, staticRenderFns } from "./loyalty-detail.vue?vue&type=template&id=031820d0&scoped=true"
import script from "./loyalty-detail.vue?vue&type=script&lang=js"
export * from "./loyalty-detail.vue?vue&type=script&lang=js"
import style0 from "./loyalty-detail.vue?vue&type=style&index=0&id=031820d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031820d0",
  null
  
)

export default component.exports